import { render } from "./TecStatistics.vue?vue&type=template&id=271c29cc&scoped=true"
import script from "./TecStatistics.vue?vue&type=script&lang=js"
export * from "./TecStatistics.vue?vue&type=script&lang=js"

import "./TecStatistics.vue?vue&type=style&index=0&id=271c29cc&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271c29cc"]])

export default __exports__